<script setup>

import BaseInputLabeled from "@/Components/UI/inputs/BaseInputLabeled.vue";
import LoadingSpinner from "@/Components/UI/loading/LoadingSpinner.vue";

defineProps({
    modelValue: {
        required: true,
    },
    loading: {
        type: Boolean
    },
    label: {
        type: String,
    },
    input: {
        default: BaseInputLabeled,
    },
    // "md" = padding-only default; "lg" matches button height; "sm" is a compact variant.
    size: {
        type: String,
        default: "md",
        validator: (value) => ["sm", "md", "lg"].includes(value),
    },
})
defineEmits(['update:modelValue'])
</script>

<template>
    <div class="relative">
        <!-- A search box is never a credential/email field — opt it out of browser
             password managers and autofill (1Password / LastPass / Bitwarden /
             Dashlane), which otherwise latch onto the «email» wording in the label. -->
        <component :is="input"
                   :label="label"
                   :model-value="modelValue"
                   :size="size"
                   input-class="pr-20"
                   autocomplete="off"
                   data-1p-ignore
                   data-lpignore="true"
                   data-bwignore
                   data-form-type="other"
                   @update:model-value="(val) => $emit('update:modelValue', val)"/>
        <p class="absolute top-1/2 -translate-y-1/2 right-8">
            <img v-show="!loading"
                 alt=""
                 src="/storage/images/search.svg">
            <LoadingSpinner v-show="loading"/>
        </p>
    </div>
</template>
